import React from "react";
import TableBody from "@mui/material/TableBody";
import FirstRow from "./FirstRow";
import SecondRow from "./SecondRow";
import { BodyProps } from "../../antibiogramTypes/AntiBiogramTypes";

const Body: React.FC<BodyProps> = ({ antibiotics, antibiogramData }) => {
  const isLastRow = (index: number) => index === antibiogramData.length - 1;
  
  return (
    <TableBody>
      {antibiogramData.map((row, rowIndex) => (
        <React.Fragment key={rowIndex}>
          <FirstRow
            row={row}
            antibiotics={antibiotics}
            rowIndex={rowIndex}
            borderBottomLeftRadius={isLastRow(rowIndex) ? "10px" : "0"}
          />
          <SecondRow
            row={row}
            antibiotics={antibiotics}
            rowIndex={rowIndex}
            borderBottomRightRadius={isLastRow(rowIndex) ? "10px" : "0"}
          />
        </React.Fragment>
      ))}
    </TableBody>
  );
};

export default Body;
